<template>
    <div class="stats" style="height: 100%">
        <!--      头部      -->
        <div class="iq-top-navbar">
            <nav class="navbar navbar-expand-lg">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 0 15px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>数据统计</el-breadcrumb-item>
                    <el-breadcrumb-item>药品时间统计</el-breadcrumb-item>
                </el-breadcrumb>
                <head-center></head-center>
            </nav>
        </div>
        <!--    内容    -->
        <div class="center-content">
            <div class="iq-card-body">
                <div class="table-top">
                    <div class="iq-search-bar">
                        <form action="#" class="searchbox">
                            <el-date-picker
                                    v-model="datepicker"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions0"
                                    size="small"
                                    style="margin-right: 10px" @change="search">
                            </el-date-picker>
                            <!--<input type="text" class="text search-input" placeholder="输入关键词搜索...">-->
                            <el-button type="primary" size="small" @click="search()">搜索</el-button>
                        </form>
                    </div>
                </div>
                <el-tabs v-model="activeName" class="stats-tab" style="height: calc(100% - 48px)">
                    <el-tab-pane label="西药时间统计" name="XDrug">
                        <el-table
                                :data="XDrugTableData"
                                stripe
                                style="width: 100%"
                                height="calc(100% - 40px)">
                            <el-table-column prop="entityName" label="药品名称" width="250"></el-table-column>
                            <el-table-column prop="entityAlias" label="药品别名" width="350" align="center"></el-table-column>
                            <el-table-column prop="entityCategory" label="药品分类" align="center"></el-table-column>
                            <el-table-column prop="stayTime" label="浏览时长" width="120" align="center"></el-table-column>
                            <el-table-column prop="lastTime" label="最后浏览时间" width="180" align="center"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <span class="primary optionBtn" @click="ToDrugDetail(scope.row)">详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination @current-change="ChangePage" :page-size="100" :current-page="PageIndex" :total="XDrugTotal" layout="total, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="中成药时间统计" name="ZDrug">
                        <el-table
                                :data="ZDrugTableData"
                                stripe
                                style="width: 100%"
                                height="calc(100% - 40px)">
                            <el-table-column prop="entityName" label="药品名称" width="250"></el-table-column>
                            <el-table-column prop="entityAlias" label="药品别名" width="350" align="center"></el-table-column>
                            <el-table-column prop="entityCategory" label="药品分类" align="center"></el-table-column>
                            <el-table-column prop="stayTime" label="浏览时长" width="120" align="center"></el-table-column>
                            <el-table-column prop="lastTime" label="最后浏览时间" width="180" align="center">
                                <template slot-scope="scope"> {{scope.row.lastTime | timefilters}} </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <span class="primary optionBtn" @click="ToDrugDetail(scope.row)">详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination @current-change="ChangePage" :page-size="100" :current-page="PageIndex" :total="ZDrugTotal" layout="total, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="中药时间统计" name="Material">
                        <el-table
                                :data="MaterialTableData"
                                stripe
                                style="width: 100%"
                                height="calc(100% - 40px)">
                            <el-table-column prop="entityName" label="名称"></el-table-column>
                            <el-table-column prop="entityAlias" label="别名" align="center"></el-table-column>
                            <!-- <el-table-column prop="source" label="来源" align="center"></el-table-column> -->
                            <el-table-column prop="entityCategory" label="分类" align="center"></el-table-column>
                            <el-table-column prop="stayTime" label="浏览时长" width="120" align="center"></el-table-column>
                            <el-table-column prop="lastTime" label="最后浏览时间" width="180" align="center"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <span class="primary optionBtn" @click="ToMaterialDetail(scope.row)">详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination @current-change="ChangePage" :page-size="100" :current-page="PageIndex" :total="MaterialTotal" layout="total, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="中药方剂时间统计" name="Herbal">
                        <el-table
                                :data="HerbalTableData"
                                stripe
                                style="width: 100%"
                                height="calc(100% - 40px)">
                            <el-table-column prop="entityName" label="名称"></el-table-column>
                            <!-- <el-table-column prop="source" label="来源" align="center"></el-table-column> -->
                            <el-table-column prop="entityCategory" label="分类" align="center"></el-table-column>
                            <el-table-column prop="stayTime" label="浏览时长" width="120" align="center"></el-table-column>
                            <el-table-column prop="lastTime" label="最后浏览时间" width="180" align="center"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <span class="primary optionBtn" @click="ToHerbalDetail(scope.row)">详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination @current-change="ChangePage" :page-size="100" :current-page="PageIndex" :total="HerbalTotal" layout="total, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="食疗药膳时间统计" name="Food">
                        <el-table
                                :data="FoodTableData"
                                stripe
                                style="width: 100%"
                                height="calc(100% - 40px)">
                            <el-table-column prop="entityName" label="名称"></el-table-column>
                            <!-- <el-table-column prop="source" label="来源" align="center"></el-table-column> -->
                            <el-table-column prop="entityCategory" label="分类" align="center"></el-table-column>
                            <el-table-column prop="stayTime" label="浏览时长" width="120" align="center"></el-table-column>
                            <el-table-column prop="lastTime" label="最后浏览时间" width="180" align="center"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <span class="primary optionBtn" @click="ToFoodDetail(scope.row)">详情</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination @current-change="ChangePage" :page-size="100" :current-page="PageIndex" :total="FoodTotal" layout="total, prev, pager, next, jumper"></el-pagination>
                    </el-tab-pane>
                </el-tabs>

            </div>
        </div>
        <!--    详情    -->
        <el-dialog title="时间统计详情" :visible.sync="dialogTableVisible">
            <el-table :data="DetailData" height="500" :header-cell-style="{background:'#F5F7FC'}">
                <el-table-column prop="userName" label="员工">
                    <template slot-scope="data">
                        <p>{{data.row.learnName}}</p>
                        <p>{{data.row.phone}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="organizationName" label="所属单位"></el-table-column>
                <el-table-column prop="departmentName" label="部门"></el-table-column>
                <el-table-column prop="userTitleName" label="职称"></el-table-column>
                <el-table-column prop="userPostName" label="职位"></el-table-column>
                <el-table-column prop="stayTime" label="浏览时长">
                    <template slot-scope="data">{{FormatSecond(data.row.stayTime)}}</template>
                </el-table-column>
                <el-table-column prop="lastTime" label="最后浏览时间"></el-table-column>
            </el-table>
            <el-pagination @current-change="ChangeDetailPage" :page-size="100" :current-page="PageIndex" :total="DetailTotal" layout="total, prev, pager, next, jumper"></el-pagination>
        </el-dialog>
    </div>
</template>

<script>
    import { STATS } from '../../../components/STATS/STATS';
    import { StrToShotDate, FormatSecond } from '../../../components/common/Date';
    export default {
        name: "DrugStats",
        data(){
            var stats = new STATS(this.TokenClient, this.Services.Healthy);
            return{
                StatsDomin:stats,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                FormatSecond:FormatSecond,
                XDrugTableData: [],
                ZDrugTableData: [],
                MaterialTableData: [],
                HerbalTableData: [],
                FoodTableData: [],
                datepicker: '',
                activeName: 'XDrug',
                statrTime: '',
                endTime: '',
                PageIndex: 1,
                PageTotal: 1,
                XDrugTotal: 1,
                ZDrugTotal: 1,
                MaterialTotal: 1,
                HerbalTotal: 1,
                FoodTotal: 1,
                dialogTableVisible: false,
                DetailData:[],
                DetailTotal: 0,
                type: 'drug',
                entityId: 0,
            }
        },
        mounted() {
            this.LoadXDrugList();
            this.LoadZDrugList();
            this.LoadMaterialList();
            this.LoadHerbalList();
            this.LoadFoodList();
        },
        methods:{
            LoadXDrugList(){
                var _this = this;
                _this.StatsDomin.XDrugBrowseList(_this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.XDrugTableData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.XDrugTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err);
                    }
                )

            },
            LoadZDrugList(){
                var _this = this;
                _this.StatsDomin.ZDrugBrowseList(_this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.ZDrugTableData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.ZDrugTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err);
                    }
                )

            },
            LoadMaterialList(){
                var _this = this;
                _this.StatsDomin.MaterialBrowseList(_this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.MaterialTableData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.MaterialTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err);
                    }
                )

            },
            LoadHerbalList(){
                var _this = this;
                _this.StatsDomin.HerbalBrowseList(_this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.HerbalTableData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.HerbalTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err);
                    }
                )

            },
            LoadFoodList(){
                var _this = this;
                _this.StatsDomin.FoodBrowseList(_this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.FoodTableData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.FoodTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err);
                    }
                )

            },
            search(){
                this.PageIndex = 1;
                this.startTime = this.datepicker ? this.datepicker[0] + ' 00:00:00' : null;
                this.endTime = this.datepicker ? this.datepicker[1] + ' 23:59:59' : null;
                switch (this.activeName) {
                    case 'XDrug':
                        this.LoadXDrugList();
                        break;
                    case 'ZDrug':
                        this.LoadZDrugList();
                        break;
                    case 'Material':
                        this.LoadMaterialList();
                        break;
                    case 'Herbal':
                        this.LoadHerbalList();
                        break;
                    case 'Food':
                        this.LoadFoodList();
                        break;
                }
            },
            ChangePage(pageIndex) {
                this.PageIndex = pageIndex;
                switch (this.activeName) {
                    case 'XDrug':
                        this.LoadXDrugList();
                        break;
                    case 'ZDrug':
                        this.LoadZDrugList();
                        break;
                    case 'Material':
                        this.LoadMaterialList();
                        break;
                    case 'Herbal':
                        this.LoadHerbalList();
                        break;
                    case 'Food':
                        this.LoadFoodList();
                        break;
                }
            },
            ChangeDetailPage(pageIndex){
                this.PageIndex = pageIndex;
                switch (this.activeName) {
                    case 'XDrug':
                        this.ToDrugDetail();
                        break;
                    case 'ZDrug':
                        this.ToDrugDetail();
                        break;
                    case 'Material':
                        this.ToMaterialDetail();
                        break;
                    case 'Herbal':
                        this.ToHerbalDetail();
                        break;
                    case 'Food':
                        this.ToFoodDetail();
                        break;
                }
            },
            ToDrugDetail(item){
                this.dialogTableVisible = true;
                var _this = this;
                _this.StatsDomin.EntityBrowseTopDetail(_this.type, item.entityKey, _this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.DetailData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.DetailTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err)
                    }
                )
            },
            ToMaterialDetail(item){
                this.dialogTableVisible = true;
                var _this = this;
                _this.type = 'material';
                _this.StatsDomin.EntityBrowseTopDetail(_this.type, item.entityKey, _this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.DetailData =data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.DetailTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err)
                    }
                )
            },
            ToHerbalDetail(item){
                this.dialogTableVisible = true;
                var _this = this;
                _this.type = 'herbal';
                _this.StatsDomin.EntityBrowseTopDetail(_this.type, item.entityKey, _this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.DetailData =data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.DetailTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err)
                    }
                )
            },
            ToFoodDetail(item){
                this.dialogTableVisible = true;
                var _this = this;
                _this.type = 'food';
                _this.StatsDomin.EntityBrowseTopDetail(_this.type, item.entityKey, _this.startTime, _this.endTime, _this.PageIndex,
                    function (data) {
                        _this.DetailData = data.data.results;
                        _this.PageIndex = data.data.pageIndex;
                        _this.PageTotal = data.data.pageCount;
                        _this.DetailTotal = data.data.dataTotal;
                    },function (err) {
                        console.log(err)
                    }
                )
            },
        },
    }
</script>

<style scoped>

    .navbar-expand-lg {
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .navbar {
        position: relative;
        height: 73px;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .header {
        flex: 1;
        text-align: right;
        margin-right: 15px;
    }

    .messages {
        margin-top: 13px;
        margin-right: 20px;
    }

    .messages .el-icon-bell {
        font-size: 26px;
    }
    /*content*/


    .table-top {
        margin-bottom: 15px;
    }

    .iq-search-bar {
        display: inline-block;
        margin-right: 20px;
    }

    .iq-search-bar .searchbox {
        width: 480px;
        position: relative;
    }

    .iq-search-bar .searchbox .search-link {
        position: absolute;
        right: 15px;
        top: 2px;
        font-size: 16px;
    }

    .iq-search-bar .search-input {
        width: 100%;
        padding: 5px 40px 5px 15px;
        border-radius: 10px;
        border: none;
        background: #ceebee;
        line-height: 1.8;
    }


</style>
<style>
    .stats-tab .el-tabs__content{
        height: calc(100% - 40px);
    }
    .stats-tab .el-tab-pane{
        height: 100%;
    }
    .stats .el-dialog{
        width: 950px;
    }
    .stats .el-dialog .el-table{
        height: 500px;
    }
</style>
